<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="receiving-drawer"
      title="Receiving Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconInbox,
  BIconClockHistory,
  BIconFileText,
  BIconTruck,
  BIconCheckCircle,
  BIconExclamationTriangle
} from "bootstrap-vue";

import ReceivingLogs from "@/components/Receiving/Logs";
import ReceivingHistory from "@/components/Receiving/ReceivingHistory";
import ReceivingOrder from  "@/components/Receiving/ReceivingOrder.vue";
// You can add more receiving components here as you create them:
// import ReceivingQueue from "@/components/Receiving/Queue";
// import ReceivingInspections from "@/components/Receiving/Inspections";
// import ReceivingReports from "@/components/Receiving/Reports";

export default {
  name: "ReceivingMain",
  components: {
    ReceivingLogs,
    ReceivingHistory,
    ReceivingOrder,
    // Add other components here as you create them
    
    // icons
    BIconList,
    BIconInbox,
    BIconClockHistory,
    BIconFileText,
    BIconTruck,
    BIconCheckCircle,
    BIconExclamationTriangle
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },

      tabs: [
           {
          title: "RECEIVING ORDERS",
          icon: "clock-history",
          roles: [
            "admin", "officeuser", "officemanager", "locationadmin",
            "locationstockperson", "warehouseuser", "warehousemanager"
          ],
          component: "ReceivingOrder"
        },
        {
          title: "RECEIVING LOGS",
          icon: "inbox",
          roles: [
            "admin", "officeuser", "officemanager", "locationadmin",
            "locationstockperson", "warehouseuser", "warehousemanager"
          ],
          component: "ReceivingLogs"
        },
         {
          title: "RECEIVING HISTORY",
          icon: "clock-history",
          roles: [
            "admin", "officeuser", "officemanager", "locationadmin",
            "locationstockperson", "warehouseuser", "warehousemanager"
          ],
          component: "ReceivingHistory"
        },
        // You can add more tabs here as you create more components:
        // {
        //   title: "RECEIVING QUEUE",
        //   icon: "clock-history",
        //   roles: [
        //     "admin", "officeuser", "officemanager", "locationadmin",
        //     "locationstockperson", "warehouseuser", "warehousemanager"
        //   ],
        //   component: "ReceivingQueue"
        // },
        // {
        //   title: "INSPECTIONS",
        //   icon: "check-circle",
        //   roles: [
        //     "admin", "officeuser", "officemanager", "warehouseuser",
        //     "warehousemanager", "locationstockperson"
        //   ],
        //   component: "ReceivingInspections"
        // },
        // {
        //   title: "RECEIVING REPORTS",
        //   icon: "file-text",
        //   roles: [
        //     "admin", "officeuser", "officemanager", "locationadmin"
        //   ],
        //   component: "ReceivingReports"
        // },
        // {
        //   title: "ISSUES & DAMAGES",
        //   icon: "exclamation-triangle",
        //   roles: [
        //     "admin", "officeuser", "officemanager", "warehouseuser",
        //     "warehousemanager", "locationstockperson"
        //   ],
        //   component: "ReceivingIssues"
        // }
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  },

  created() {
    this.initializeUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}

/* Optional: Add some custom styling for receiving */
::v-deep .nav-tabs .nav-link.active {
  background-color: #20c997;
  border-color: #20c997;
  color: white;
}

::v-deep .nav-tabs .nav-link:hover {
  border-color: #198754;
}
</style>


// WEBPACK FOOTER //
// src/components/Receiving/ReceivingMain.vue